// extracted by mini-css-extract-plugin
module.exports = {"oops":"NotFound_oops__3eFq6"};